<template>
  <crm-settings />
</template>

<script>
import CrmSettings from "@/components/3pl/CRM/Settings/Settings";

export default {
  components: {
    CrmSettings,
  },
};
</script>

<style></style>
